





























import { defineComponent, PropType, ref } from "@vue/composition-api";
import useFileSize from "@/hooks/useCheckFileSize";
import useUploadedFilePreview from "@/hooks/useUploadedFilePreview";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseInputFile from "@/components/BaseInputFile";
import DragDropFiles from "@/components/DragDropFiles";
import UploadedFilesEditModal from "@/components/UploadedFilesEditModal";

export default defineComponent({
  name: "EditPostDropZone",
  components: { UploadedFilesEditModal, BaseInputFile, BaseButton, BaseIcon, DragDropFiles },
  props: {
    showTooltip: { type: Boolean, default: false },
    multiple: { type: Boolean },
    allowedFileTypes: { type: Array as PropType<string[]>, required: true },
    dragAndDropProhibited: { type: Boolean, default: false },
    nativeUploadingAvailable: { type: Boolean, default: true },
  },
  setup(_, { emit }) {
    const isDrag = ref(false);
    const {
      files: droppedFiles,
      updateUploadedFile,
      removeFileFromUploadedList,
      uploadFiles,
    } = useUploadedFilePreview();

    const { checkFilesSize } = useFileSize();

    const onDragHandler = (v: boolean) => {
      isDrag.value = v;
      emit("dragging", v);
    };

    const onDropFiles = (files: File[]) => {
      droppedFiles.value = checkFilesSize(files);
    };

    return {
      isDrag,
      onDragHandler,
      droppedFiles,
      onDropFiles,
      uploadFiles,
      updateUploadedFile,
      removeFileFromUploadedList,
    };
  },
});
